// @flow

import { combineReducers } from 'redux';

import details from './details/details.reducer';
import button from './button/button.reducer';

export default combineReducers({
  details,
  button,
});
